<app-instagram-gallery *ngIf="source == 'instagram'" #instaRef [autoPublish]="autoPublish"
    (autoPublishChange)="autoPublish = $event" [selectedItems]="selectedItems"
    (selectedItemsChange)="onSelectedItemsChange($event)" [showContent]="showContent"
    [showAutoPublish]="showAutoPublish" [enablePanelAdjustment]="enablePanelAdjustment"
    (hashtagResults)="hashtagResults.emit($event)" (tagsResults)="tagsResults.emit($event)"
    (mediaResults)="mediaResults.emit($event)" (storiesResults)="storiesResults.emit($event)"
    (hashtagChange)="onHashtagChange($event)" [isFeed]="isFeed"
    (selectedFacebookAccountIdChange)="onSelectedFacebookAccountIdChange($event)"
    (selectedInstagramAccountIdChange)="onSelectedInstagramAccountIdChange($event)"
    (activeTabChange)="onActiveTabChange($event)" (showConectAccountChange)="showConectAccount = $event"
    [showConectAccount]="showConectAccount" (openPostDialog)="onOpenPostDialog($event)"></app-instagram-gallery>


<app-tiktok-gallery *ngIf="source == 'tiktok'" [autoPublish]="autoPublish" [isFeed]="isFeed" (autoPublishChange)="autoPublish = $event"
    [showAutoPublish]="showAutoPublish" [showContent]="showContent" [selectedItems]="selectedItems"
    (selectedItemsChange)="selectedItems = $event" [showContent]="showContent" [showConectAccount]="showConectAccount"
    (showConectAccountChange)="showConectAccount = $event" [enablePanelAdjustment]="enablePanelAdjustment"
    (mediaResults)="mediaResults.emit($event)" [selectedTikTokOpenId]="selectedTikTokOpenId" (connectTikTok)="conectTikTok()"
    (selectedTikTokOpenIdChange)="selectedTikTokOpenId = $event" (openPostDialog)="onOpenPostDialog($event)">
</app-tiktok-gallery>


<app-google-gallery *ngIf="source == 'google'" [autoPublish]="autoPublish" [isFeed]="isFeed" (autoPublishChange)="autoPublish = $event"
    [showContent]="showContent" [showAutoPublish]="showAutoPublish" [enablePanelAdjustment]="enablePanelAdjustment"
    [selectedItems]="selectedItems" (selectedItemsChange)="onSelectedItemsChange($event)"
    [showConectAccount]="showConectAccount" (showConectAccountChange)="showConectAccount = $event"
    [selectedGoogleAccountId]="selectedGoogleAccountId" (connectGoogle)="googleConnection()"
    (selectedGoogleAccountIdChange)="selectedGoogleAccountId = $event" [selectedChannelId]="selectedChannelId"
    (selectedChannelIdChange)="selectedChannelId = $event" (mediaResults)="mediaResults.emit($event)"
    (openPostDialog)="onOpenPostDialog($event)"></app-google-gallery>













<p-toast position="top-right"></p-toast>

<app-dialog-aguarde [visible]="displayAguarde" [baseZIndex]="16000"></app-dialog-aguarde>

<p-dialog [(visible)]="postDialogVisible" [modal]="true" [dismissableMask]="true" [closable]="true"
    [style]="{ width: '100%', maxWidth: '420px' }" class="dialog-article p-0 ss-g-dialog-sized" (onHide)="closePostDialog()">

    <ng-container *ngIf="selectedPost">
        <div class="card m-0 p-0 border-round shadow-2">

            <!-- Mídia -->
            <div class="w-full border-round-top overflow-hidden">
                <swiper *ngIf="selectedPost.media_type === 'CAROUSEL_ALBUM'" [pagination]="{ clickable: true }"
                    [navigation]="true" class="w-full h-60">
                    <ng-template swiperSlide *ngFor="let child of selectedPost.children?.data">
                        <ng-container [ngSwitch]="child.media_type">
                            <img *ngSwitchCase="'IMAGE'" [src]="child.media_url" class="w-full h-full object-cover" />
                            <video *ngSwitchCase="'VIDEO'" [src]="child.media_url" controls muted
                                class="w-full h-full object-cover"></video>
                        </ng-container>
                    </ng-template>
                </swiper>

                <img *ngIf="selectedPost.media_type === 'IMAGE' && selectedPost.source !== 'tiktok' && selectedPost.source !== 'youtube'"
                    [src]="selectedPost.media_url" class="w-full h-60 object-cover" />

                <video *ngIf="selectedPost.media_type === 'VIDEO' && selectedPost.source !== 'tiktok' && selectedPost.source !== 'youtube'"
                    [poster]="selectedPost.thumbnail_url" [src]="selectedPost.media_url"
                    class="w-full h-60 object-cover">
                </video>

                <div class="tiktok-player">
                    <iframe *ngIf="selectedPost.media_type === 'VIDEO' && selectedPost.source === 'tiktok'"
                        [src]="selectedPost.safe_player_url" frameborder="0" class="w-full"
                        allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
                    </iframe>
                </div>
                <div class="youtube-player" style="text-align: center;">
                    <iframe *ngIf="selectedPost.media_type === 'VIDEO' && selectedPost.source === 'youtube'"
                        [src]="selectedPost.safe_player_url" frameborder="0" width="100%" height="230"
                        allow="autoplay; encrypted-media" allowfullscreen></iframe>
                </div>
            </div>

            <!-- Conteúdo -->
            <div class="p-4">

                <p class="text-700 text-sm mb-3 breakable white-space-pre-line">{{ selectedPost.caption }}</p>

                <div class="flex align-items-center text-sm text-500">
                    <i class="pi pi-calendar mr-2"></i>
                    <span>{{ selectedPost.timestamp | date:'dd MMM yyyy' }}</span>
                </div>

                <div class="mt-3">
                    <a [href]="selectedPost.permalink" target="_blank" class="text-primary text-sm font-medium">
                        Ver no {{ selectedPost.source === 'tiktok' ? 'TikTok' : selectedPost.source === 'youtube' ? 'Youtube' : 'Instagram' }}
                    </a>
                </div>
            </div>

        </div>
    </ng-container>

</p-dialog>

<p-dialog header="Limite de Hashtags Atingido" [(visible)]="showHashtagLimitDialog" [modal]="true" [closable]="true"
    class="ss-g-dialog-sized">
    <p>{{ hashtagLimitMessage }}</p>
    <ng-template pTemplate="footer">
        <button pButton type="button" label="OK" (click)="showHashtagLimitDialog = false"></button>
    </ng-template>
</p-dialog>